export default "__VITE_ASSET__f7c0973d__"